import glamorous from "glamorous"
import style from "utils/style"

export default glamorous.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
})

export const InlineContainer = glamorous.div(
  {
    display: "flex",
    width: "100%",
    alignItems: "center",
    [style.size.mobile]: {
      flexDirection: "column",
    },
  },
  ({ inline }) => ({
    flexDirection: inline ? "row" : "column",
  })
)



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FieldParts/FieldContainer/index.js